var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"button-arrow",class:{ 'button-arrow--right': _vm.direction === 'right' },attrs:{"disabled":_vm.disabled}},[_c('img',{attrs:{"src":require("../../assets/icons/arrow.svg"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }